import * as React from "react";
import { Toaster as Sonner, toast as sonnerToast } from "sonner";

type ToasterProps = React.ComponentProps<typeof Sonner>;

const commonProps = {
  className: "toaster group",
  toastOptions: {
    classNames: {
      toast:
        "group toast group-[.toaster]:bg-background group-[.toaster]:text-foreground group-[.toaster]:border-border group-[.toaster]:shadow-lg",
      description: "group-[.toast]:text-muted-foreground",
      actionButton: "group-[.toast]:bg-primary group-[.toast]:text-primary-foreground",
      cancelButton: "group-[.toast]:bg-muted group-[.toast]:text-muted-foreground",
    },
  },
} satisfies Partial<ToasterProps>;

function getClientTheme(): ToasterProps["theme"] {
  // Keep this SSR/SSG-safe: only read `document` when it exists.
  if (typeof document === "undefined") return "system";

  // If the site uses a `dark` class on <html>, reflect that in Sonner.
  // Otherwise default to system.
  const isDark = document.documentElement.classList.contains("dark");
  return isDark ? "dark" : "system";
}

function ClientToaster(props: ToasterProps) {
  const theme = getClientTheme();
  return <Sonner theme={theme} {...commonProps} {...props} />;
}

function ServerToaster(props: ToasterProps) {
  // SSR/SSG: avoid touching theme logic (which can rely on window/localStorage)
  return <Sonner theme={"system"} {...commonProps} {...props} />;
}

const Toaster = (props: ToasterProps) => {
  return typeof window === "undefined" ? <ServerToaster {...props} /> : <ClientToaster {...props} />;
};

// Re-export toast in a way that counts as a usage (avoids unused import warnings during SSG server build)
export const toast = sonnerToast;
export { Toaster };
